/**
 * Delayed Third-Party Script Loader
 *
 * Defers loading of non-critical third-party scripts until user interaction,
 * improving initial page load performance and Core Web Vitals.
 *
 * Scripts with [data-delayed-src] attribute will be loaded when:
 * - User scrolls, clicks, touches, or moves mouse
 * - Or after 4 seconds (fallback for non-interactive users/bots)
 */
(function() {
  const INTERACTION_EVENTS = ['scroll', 'click', 'touchstart', 'mousemove', 'keydown'];
  const FALLBACK_DELAY = 4000; // 4 seconds

  let hasLoaded = false;
  let fallbackTimer = null;

  function loadDelayedScripts() {
    if (hasLoaded) return;
    hasLoaded = true;

    // Clear fallback timer
    if (fallbackTimer) {
      clearTimeout(fallbackTimer);
    }

    // Remove event listeners
    INTERACTION_EVENTS.forEach(event => {
      document.removeEventListener(event, loadDelayedScripts);
    });

    // Find and load all delayed scripts
    const delayedScripts = document.querySelectorAll('script[data-delayed-src]');

    delayedScripts.forEach(placeholder => {
      const script = document.createElement('script');
      script.src = placeholder.dataset.delayedSrc;

      // Copy attributes
      if (placeholder.dataset.delayedType) {
        script.type = placeholder.dataset.delayedType;
      }
      if (placeholder.id) {
        script.id = placeholder.id;
      }

      // Insert and remove placeholder
      placeholder.parentNode.insertBefore(script, placeholder);
      placeholder.remove();
    });

    // Dispatch event for other scripts that might need to know
    window.dispatchEvent(new CustomEvent('delayed-scripts:loaded'));
  }

  // Listen for user interaction
  INTERACTION_EVENTS.forEach(event => {
    document.addEventListener(event, loadDelayedScripts, {
      passive: true,
      once: true
    });
  });

  // Fallback: load after delay even without interaction
  fallbackTimer = setTimeout(loadDelayedScripts, FALLBACK_DELAY);

  // Also load if page is already scrolled (user might have scrolled before JS loaded)
  if (window.scrollY > 0) {
    loadDelayedScripts();
  }
})();
